import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';

const Returns = () => {
  const { t } = useLanguage();

  return (
    <>
      <div className="min-h-screen py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-xl shadow-lg p-8"
          >
            <h1 className="text-3xl font-bold text-gray-900 mb-6">
              {t('returnsTitle')}
            </h1>
            <div className="prose max-w-none text-gray-600">
              <p className="mb-4 text-sm">
                מדיניות זו חלה על עסקאות המבוצעות באתר Printeam, המופעל על ידי <strong>א.ז. שירותי מחשוב ולוגיסטיקה</strong>, האורגים 32, חולון.
              </p>
              <h2 className="text-2xl font-semibold mt-2 mb-4">מדיניות ביטולים, החזרות והחלפות – מוצרים מותאמים אישית</h2>

              <h3 className="text-xl font-semibold mt-6 mb-3">מוצרים מותאמים אישית</h3>
              <p>
                בהתאם להוראות חוק הגנת הצרכן, תשמ״א–1981, ולנוהג המקובל בענף הדפוס והייצור בהתאמה אישית, לא ניתן לבטל עסקה, להחזיר מוצר או לקבל החזר כספי עבור מוצרים שיוצרו או הוזמנו בהתאמה אישית ללקוח, לרבות מוצרים עם הדפסה, מיתוג, עיצוב ייחודי או כל שינוי לפי דרישת הלקוח.
              </p>
              <p>
                הזמנה של מוצר מותאם אישית נחשבת סופית ומחייבת מרגע אישורה, גם אם תהליך הייצור או ההדפסה טרם החל בפועל, ולא ניתן לבטלה מכל סיבה שהיא, לרבות שינוי דעת הלקוח, טעות בהזמנה, עיכוב בייצור או כל נסיבה אחרת שאינה באחריות החברה.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">חריגים</h3>
              <p>
                חריג למדיניות זו יחול אך ורק במקרה של פגם בייצור או טעות שמקורה בחברה. במקרה כזה, יש ליצור קשר תוך 7 ימים ממועד קבלת המוצר, בצירוף:
              </p>
              <ul>
                <li>מספר הזמנה</li>
                <li>תיאור מפורט של הבעיה</li>
                <li>תיעוד חזותי ברור (תמונות)</li>
              </ul>
              <p>
                לאחר בדיקה ואימות, החברה תפעל לפי שיקול דעתה לתיקון, החלפה או החזר כספי, בהתאם לנסיבות המקרה.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default Returns;
